<template>
  <nav class="navbar navbar-expand-lg navbar-dark q-navbar sticky-top">
    <div class="container q-container">
      <RouterLink class="navbar-brand d-flex align-items-center gap-3" to="/" @click="closeMobileMenu">
        <span class="q-logo">
          <img src="../assets/mitton_logo.png" alt="Quick Quiz AI logo" />
        </span>
        <span class="q-brand">Quick Quiz AI</span>
      </RouterLink>

      <button
        class="navbar-toggler q-toggler"
        type="button"
        aria-controls="qNav"
        :aria-expanded="isOpen ? 'true' : 'false'"
        aria-label="Toggle navigation"
        @click="toggleMobileMenu"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div ref="navCollapse" class="collapse navbar-collapse" id="qNav">
        <ul class="navbar-nav mx-auto q-navlinks mt-3 mt-lg-0">
          <li class="nav-item">
            <RouterLink to="/" class="nav-link q-link" active-class="active" @click="closeMobileMenu">Home</RouterLink>
          </li>
          <li class="nav-item">
            <RouterLink to="/features" class="nav-link q-link" active-class="active" @click="closeMobileMenu"
              >Features</RouterLink
            >
          </li>
          <li class="nav-item">
            <RouterLink to="/downloads" class="nav-link q-link" active-class="active" @click="closeMobileMenu"
              >Downloads</RouterLink
            >
          </li>
          <li class="nav-item">
            <RouterLink to="/pricing" class="nav-link q-link" active-class="active" @click="closeMobileMenu"
              >Pricing</RouterLink
            >
          </li>
        </ul>

        <div class="d-flex align-items-center q-actions mt-3 mt-lg-0">
          <RouterLink to="/login" class="btn q-login" @click="closeMobileMenu">
            <i class="bi bi-person-circle me-2"></i>Log In
          </RouterLink>
          <RouterLink to="/notes" class="btn q-cta" @click="closeMobileMenu">
            <i class="bi bi-camera me-2"></i>Analyze Notes
          </RouterLink>
        </div>
      </div>
    </div>
  </nav>
</template>

<script>
import { Collapse } from "bootstrap";

export default {
  name: "QuickQuizNavbar",
  data() {
    return {
      isOpen: false,
      collapseInstance: null,
    };
  },
  mounted() {
    const el = this.$refs.navCollapse;
    if (!el) return;

    this.collapseInstance = Collapse.getInstance(el) || new Collapse(el, { toggle: false });

    el.addEventListener("shown.bs.collapse", () => (this.isOpen = true));
    el.addEventListener("hidden.bs.collapse", () => (this.isOpen = false));
  },
  methods: {
    toggleMobileMenu() {
      if (!window.matchMedia("(max-width: 62rem)").matches) return;

      if (!this.collapseInstance && this.$refs.navCollapse) {
        this.collapseInstance = new Collapse(this.$refs.navCollapse, { toggle: false });
      }

      this.isOpen ? this.collapseInstance.hide() : this.collapseInstance.show();
    },
    closeMobileMenu() {
      if (!window.matchMedia("(max-width: 62rem)").matches) return;

      if (!this.collapseInstance && this.$refs.navCollapse) {
        this.collapseInstance = new Collapse(this.$refs.navCollapse, { toggle: false });
      }

      this.collapseInstance.hide();
    },
  },
};
</script>

<style scoped>
/* Navbar shell */
.q-navbar {
  background: rgba(10, 12, 18, 0.78);
  backdrop-filter: blur(1.2rem);
  -webkit-backdrop-filter: blur(1.2rem);
  border-bottom: 0.0625rem solid rgba(255, 255, 255, 0.08);
}

/* Subtle top glow line */
.q-navbar::before {
  content: "";
  position: absolute;
  inset: 0 0 auto 0;
  height: 0.0625rem;
  background: linear-gradient(90deg, rgba(45, 108, 255, 0.35), rgba(124, 58, 237, 0.35), rgba(255, 61, 141, 0.25));
  opacity: 0.45;
}

/* spacing */
.q-container {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

/* Brand */
.navbar-brand {
  text-decoration: none;
}

.q-logo {
  width: 3.1rem;
  height: 3.1rem;
  border-radius: 1.25rem;
  overflow: hidden;
  flex: 0 0 auto;
  background: rgba(255, 255, 255, 0.06);
  border: 0.0625rem solid rgba(255, 255, 255, 0.12);
  box-shadow: 0 0.9rem 2.2rem rgba(0, 0, 0, 0.35);
}

.q-logo img {
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover; /* keeps logo from stretching */
  object-position: center;
}

.q-brand {
  font-weight: 900;
  letter-spacing: -0.03rem;
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.95);
}

/* Toggler */
.q-toggler {
  border: 0;
  box-shadow: none !important;
  padding: 0.55rem 0.7rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 0.0625rem solid rgba(255, 255, 255, 0.10);
}
.q-toggler:hover {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.16);
}

/* Links */
.q-navlinks {
  gap: 0.35rem;
}

.q-link {
  position: relative;
  font-weight: 850;
  color: rgba(255, 255, 255, 0.78) !important;
  padding: 0.6rem 0.9rem !important;
  border-radius: 0.95rem;
  transition: background 160ms ease, color 160ms ease, transform 160ms ease;
}

.q-link:hover {
  color: rgba(255, 255, 255, 0.96) !important;
  background: rgba(255, 255, 255, 0.06);
  transform: translateY(-0.05rem);
}

.active {
  color: rgba(255, 255, 255, 0.97) !important;
  background: rgba(255, 255, 255, 0.06);
}

.active::after {
  content: "";
  position: absolute;
  left: 22%;
  right: 22%;
  bottom: 0.35rem;
  height: 0.18rem;
  border-radius: 62.5rem;
  background: linear-gradient(90deg, #2d6cff, #7c3aed, #ff3d8d);
  opacity: 0.9;
}

/* Right actions */
.q-actions {
  gap: 0.65rem;
}

/* Log In pill */
.q-login {
  border-radius: 62.5rem;
  padding: 0.62rem 1.05rem;
  font-weight: 900;
  color: rgba(255, 255, 255, 0.92);
  border: 0.0625rem solid rgba(255, 255, 255, 0.18);
  background: rgba(255, 255, 255, 0.05);
  transition: transform 160ms ease, background 160ms ease, border-color 160ms ease;
}

.q-login:hover {
  transform: translateY(-0.05rem);
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.26);
  color: rgba(255, 255, 255, 0.97);
}

/* CTA */
.q-cta {
  border-radius: 62.5rem;
  padding: 0.62rem 1.15rem;
  font-weight: 950;
  color: #fff;
  border: 0;
  background: linear-gradient(90deg, #2d6cff 0%, #7c3aed 55%, #ff3d8d 120%);
  box-shadow: 0 1.1rem 2.3rem rgba(0, 0, 0, 0.35);
  transition: transform 160ms ease, filter 160ms ease;
}

.q-cta:hover {
  transform: translateY(-0.05rem);
  filter: brightness(1.06);
}

/* Mobile: make collapsed menu look like a glass card */
@media (max-width: 62rem) {
  .navbar-collapse {
    margin-top: 0.75rem;
    padding: 0.75rem;
    border-radius: 1.25rem;
    background: rgba(10, 12, 18, 0.75);
    border: 0.0625rem solid rgba(255, 255, 255, 0.10);
    box-shadow: 0 1.6rem 3.8rem rgba(0, 0, 0, 0.45);
  }

  .q-navlinks {
    gap: 0.25rem;
  }

  .q-actions {
    width: 100%;
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 0.65rem;
  }

  .q-login,
  .q-cta {
    width: 100%;
    text-align: center;
  }
}
</style>
